// Pure read helper used by AnalyticsBootstrap to decide whether analytics
// SDKs may initialize. Mirrors the query in ConsentGate so the two stay in
// lockstep — a user must have an active 'granted' CHD consent row before
// any third-party SDK (PostHog, Sentry) is loaded or identified.

import { supabase } from "@/integrations/supabase/client";
import { CHD_CONSENT_TYPE } from "@/lib/consent";

export async function hasActiveChdConsent(userId: string): Promise<boolean> {
  const { data, error } = await supabase
    .from("consent_events")
    .select("action")
    .eq("user_id", userId)
    .eq("consent_type", CHD_CONSENT_TYPE)
    .order("created_at", { ascending: false })
    .limit(1)
    .maybeSingle();
  if (error) {
    console.error("[consent-status] load failed", error);
    return false;
  }
  return data?.action === "granted";
}
